import { Condition } from "../../Pages/Measure/VisibilityDependency/Condition";
import { IGridViewSaveDataField } from "./IGridViewSaveDataField";
import { SortCondition } from "../../Pages/Measure/VisibilityDependency/SortCondition";

export class GridViewSaveData {
    id: number;
    name: string;
    isPublic: boolean;
    isAdministrative: boolean;
    art: number;
    useAvatars: boolean;
    singleLineDisplay: boolean;
    resultLineDisplay: boolean;
    /**Option to hide duplicate rows in the table (by row ID field) */
    hideDuplicatesOption: boolean;
    fields: IGridViewSaveDataField[];
    childViewId: number;
    isCopy: boolean;
    filters: Condition[];
    sorts: SortCondition;
    inlineEdit: boolean;
    newMeasureTemplateIds: string;
    rowClickUrl: string;
    rowClickUrlUsePopup: boolean;
    showOnlySelectedReporting: boolean;
    showOnlySelectedExcel: boolean;
    hideButtonExport: boolean;
    selectedExcelTemplates: number[];
    selectedReports: number[];
    dataTemplateId: number;
    editingScenario: boolean;
    groupName: string;
    lazyLoadingAmount?: number;
}